import React from 'react';
import styled from 'styled-components';

import {withTranslation} from 'react-i18next';
import {Spinner, colorTheme} from './ui-toolkit';

import tarasaLogoLight from './img/logo/Tarasa-logo-black-gold.png';
import tarasaLogoDark from './img/logo/Tarasa-logo-white-gold.png';
import {BrandLogo} from './shared-components/grid-features/login/LoginLogo';
import {FooterGimmickBar} from './ui-toolkit/modal/modal-features/Dialog';

function LoadingApp({t, message, children}) {
    return (
        <>
            <Wrapper>
                <LoadingContent>
                    <BrandLogo style={{'--logo-01': 'var(--img-logo)'}} />
                    <LoadingText>
                        {children != null && message != null && t('generalShared.loading')}
                        {children}
                        {message && <p>{t(message)}</p>}
                    </LoadingText>
                </LoadingContent>
            </Wrapper>
            <Wrapper>
                <Spinner />
            </Wrapper>
            <GimmickBar />
        </>
    );
}

export default withTranslation()(LoadingApp);

const Wrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    ${Spinner} {
        width: 23rem;
        height: 23rem;
        font-size: 8px;
        -webkit-animation: load6 9s infinite ease, round 1s infinite ease;
        animation: load6 9s infinite ease, round 1s infinite ease;
        color: var(--default-text-color);
        opacity: 0.3;
    }

    ${BrandLogo} {
        margin-bottom: 30px;
        width: 200px;
    }

    ${colorTheme({
        '--img-logo     ': {
            dark: `url(${tarasaLogoDark})`,
            light: `url(${tarasaLogoLight})`,
        },
    })};
`;

const LoadingText = styled.div`
    text-align: center;
`;
const LoadingContent = styled.div`
    width: 23rem;
    margin-top: 55px;
    display: flex;
    justify-content: center;
`;

const GimmickBar = styled(FooterGimmickBar)`
    height: 8px;
    position: fixed;
    width: 100%;
`;
